import React from 'react';

const MongoDB_StudyPlan = () => {
  return (
    <div>
      <h1>MongoDB_StudyPlan Component</h1>
      <p>This is the MongoDB_StudyPlan page.</p>
    </div>
  );
};

export default MongoDB_StudyPlan;
